import React from "react";

/**
 * HeroMedia — LCP-optimised responsive hero.
 *
 * Aug 2026 rewrite: dropped the desktop autoplay <video> branch entirely
 * (was a 1.5 MB MP4 that never earned its keep) in favour of a single
 * static family portrait shipped as a <picture> with three WebP widths
 * and a JPEG fallback. Same image works cleanly on:
 *   • Mobile Safari + Android Chrome (all sizes)
 *   • Facebook / Instagram in-app browsers (they were rejecting the
 *     <video> autoplay on iOS with FBAN UA — this bypasses the issue)
 *   • Desktop Chrome / Firefox / Safari
 *
 * LCP wins:
 *   • fetchpriority="high" + loading="eager" so the browser races this
 *     image against everything else
 *   • explicit width/height so the layout is reserved before the image
 *     paints (no shift)
 *   • WebP srcset with `sizes="100vw"` so a phone gets the 480 variant
 *     (~25 KB) while a retina laptop pulls the 1200 variant (~94 KB)
 *   • The image is preloaded from index.html so the request kicks off
 *     during HTML parse, not after CSS/JS finishes
 */
export default function HeroMedia({
  alt = "A family unboxing THE BUTCHER BOX in their kitchen",
  className = "hero-img",
  testid = "hero-media",
}) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet="/media/hero-480.webp 480w, /media/hero-768.webp 768w, /media/hero-1200.webp 1200w"
        sizes="100vw"
      />
      <img
        src="/media/hero-fallback.jpg"
        alt={alt}
        className={className}
        width={896}
        height={1200}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        data-testid={testid}
      />
    </picture>
  );
}
